import React from 'react';
import Card, {
	CardBody,
	CardFooter,
	CardHeader,
	CardLabel,
	CardSubTitle,
	CardTitle,
} from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';
import Badge from '../../components/bootstrap/Badge';
import { priceFormat } from '../../helpers/helpers';
import { layoutMenu } from '../../menu';
import '../common/Card.css';
import useDarkMode from '../../hooks/useDarkMode';
import PlaceholderImage from '../../components/extras/PlaceholderImage';
import { useTranslation } from 'react-i18next';

const CommonProductView = ({ id, name, category, quantity, img, price, currency, linkPath }) => {
	const { t } = useTranslation();
	const { darkModeStatus } = useDarkMode();

	return (
		<Card className='card-cus' style={{ width: '90%', cursor: 'pointer' }}>
			<CardHeader>
				<CardLabel style={{ textAlign: 'left', width: '100%' }}>
					<CardTitle style={{ fontSize: '15px' }}>
						{name.length > 28 ? name.substring(0, 28) + '...' : name}
					</CardTitle>
				</CardLabel>
			</CardHeader>
			<CardBody
				style={{
					paddingBottom: 0,
					paddingTop: 0,
					position: 'relative',
				}}>
				{img ? (
					<img
						style={{
							objectFit: 'cover',
							width: '100%',
							height: '300px',
							borderRadius: '12px',
							paddingBottom: 0,
						}}
						src={img}
						alt=''
						width={100}
						height={100}
						className='mx-auto d-block img-fluid mb-3'
					/>
				) : (
					<PlaceholderImage
						width={250}
						height={150}
						className='mx-auto d-block img-fluid mb-3 rounded'
					/>
				)}
				{price && (
					<Badge
						color='success'
						className='ms-2'
						style={{
							position: 'absolute',
							bottom: '20px',
							right: '26px',
							borderRadius: '2 2 2 2',
							fontSize: '12px',
						}}>
						{currency + ' ' + priceFormat(price)}
					</Badge>
				)}
				{quantity === true ? (
					<Badge color='danger' className='ms-2 card-badge-a'>
						{t('Out Of Stock')}
					</Badge>
				) : (
					<p />
				)}
			</CardBody>
			<CardFooter className='shadow-3d-container' style={{ paddingTop: '8px' }}>
				<Button
					color={darkModeStatus ? 'dark' : 'info'}
					className={`w-100 mb-4-${darkModeStatus ? 'light' : 'dark'}`}
					style={{
						fontSize: '12px',
						paddingBottom: '10px',
					}}
					size='lg'
					tag='a'
					to={`../${linkPath || layoutMenu.view_pro.path}/${id}`}>
					{t('View Product')}
				</Button>
			</CardFooter>
		</Card>
	);
};

export default CommonProductView;
